import { Reveal } from "@/lib/reveal";
import { IMAGES } from "@/data";
import { useLang } from "@/lib/lang";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function About() {
  const { t, lang } = useLang();
  const arrow = lang === "he" ? `← ${t.about.link}` : `${t.about.link} →`;

  return (
    <section className="pad two-col section-line" id="about" data-testid="about-section">
      <Reveal className="frame p45" data-testid="about-image">
        <img src={IMAGES.portrait} alt="Benjamin teaching warriors" loading="lazy" />
      </Reveal>
      <div>
        <Reveal className="eyebrow">{t.about.eyebrow}</Reveal>
        <Reveal delay={0.05}>
          <h2 className="big" data-testid="about-title">{t.about.title}</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="body">{t.about.p1}</p>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="body" style={{ marginBottom: 40 }}>{t.about.p2}</p>
        </Reveal>
        <Reveal delay={0.2}>
          <a href="#framework" className="link-arrow" data-testid="about-framework-link"
            onClick={(e) => { e.preventDefault(); scrollTo("#framework"); }}>
            {arrow}
          </a>
        </Reveal>
      </div>
    </section>
  );
}
